const CLASS_SEE_ALL = '.js-ao-clp-serp-countries__see-all';
const CLASS_COUNTRY_LIST = '.js-ao-clp-serp-countries__country-list';

export default function AOClpSerpCountries() {
  let $seeAllButtons = null;

  const initiate = () => {
    $seeAllButtons = $(CLASS_SEE_ALL);

    if ($seeAllButtons) {
      $seeAllButtons.click((event) => {
        const $clickedButton = $(event.currentTarget);
        const $listItems = $clickedButton.prev(CLASS_COUNTRY_LIST).children();
        $listItems.slice(7).show();
        $clickedButton.remove();
      });
    }
  };

  return { initiate };
}
